import { useDisclosure } from '@/hooks';
import { Button } from 'antd';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import MailTecnoSpeedModal from './InvoiceSendEmailInternal';

export function InvoiceMailTecnoSpeed() {
  const { invoiceId } = useInvoiceFormContext();

  const [sendEmailInvoiceVisible, sendEmailInvoiceAction] =
    useDisclosure(false);

  return (
    <>
      <Button block type="primary" onClick={sendEmailInvoiceAction.open}>
        Enviar E-mail
      </Button>

      <MailTecnoSpeedModal
        invoiceId={Number(invoiceId)}
        open={sendEmailInvoiceVisible}
        onClose={sendEmailInvoiceAction.close}
      />
    </>
  );
}
